import 'react-perfect-scrollbar/dist/css/styles.css';
import React, { useState } from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import theme from 'src/theme';
import routes from 'src/routes';
import AuthContext from 'src/Context/AuthContext';
import { Provider } from 'react-redux';
import store from 'src/models/store';
import { SnackbarProvider } from 'notistack';

const App = () => {
  const routing = useRoutes(routes);

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <GlobalStyles />
        <SnackbarProvider maxSnack={1}>{routing}</SnackbarProvider>
      </Provider>
    </ThemeProvider>
  );
};

export default App;
